/*
 * @Author: Chao Yang
 * @Date: 2022-07-01 09:03:00
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-07-01 16:16:26
 */
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { RootProxy } from 'src/app/domain/proxy/root/index';
@Injectable({
  providedIn: 'root',
})
export class RootService {
  public viewDataForAllInvestors: boolean;
  public viewDataForAllInvestorsSubject: Subject<boolean>;

  constructor(private rootProxy: RootProxy) {
    this.viewDataForAllInvestors = false;
    this.viewDataForAllInvestorsSubject = new Subject<boolean>();
  }

  initialize() {
    this.rootProxy.getViewDataForAllInvestors().subscribe((viewDataForAllInvestors) => {
      this.viewDataForAllInvestors = viewDataForAllInvestors;
      this.viewDataForAllInvestorsSubject.next(viewDataForAllInvestors);
    });
  }

  updateViewDataForAllInvestors(viewDataForAllInvestors: boolean) {
    this.viewDataForAllInvestors = viewDataForAllInvestors;
    return this.rootProxy.updateViewDataForAllInvestors(viewDataForAllInvestors);
  }
}
